module.exports = __webpack_public_path__ + "static/media/ultra.7dbe67ca.png";